import { useState } from 'react';
import { useIntl } from 'react-intl';
import { formatError } from '@/shared/api';
import { type UseScheduleManagementReturn } from '../hooks/useScheduleManagement';
import ConfigurationModal from '../../configuration/components/ConfigurationModal';
import PauseScheduleModal from './PauseScheduleModal';
import ScheduleActivitiesModal from './ScheduleActivitiesModal';

interface Props {
  countryCode: string;
  management: UseScheduleManagementReturn;
}

export default function ScheduleManagementModals({ countryCode, management }: Props) {
  const {
    configSchedule,
    closeConfigModal,
    saveConfiguration,
    pauseScheduleId,
    cancelPause,
    confirmPause,
    pauseSchedule,
    activitiesScheduleId,
    closeActivitiesModal,
  } = management;
  const [pauseError, setPauseError] = useState<string | null>(null);
  const intl = useIntl();

  const handleCancelPause = () => {
    if (pauseSchedule.isPending) return;
    setPauseError(null);
    cancelPause();
  };

  const handleConfirmPause = async () => {
    setPauseError(null);
    try {
      await confirmPause();
    } catch (error) {
      setPauseError(formatError(error, intl.formatMessage({ id: 'schedule.pause.error' })));
    }
  };

  return (
    <>
      <ConfigurationModal
        schedule={configSchedule}
        countryCode={countryCode}
        onClose={closeConfigModal}
        onSubmit={saveConfiguration}
      />
      <PauseScheduleModal
        isOpen={pauseScheduleId !== null}
        onClose={handleCancelPause}
        onConfirm={handleConfirmPause}
        isSubmitting={pauseSchedule.isPending}
        error={pauseError}
      />
      {activitiesScheduleId !== null && (
        <ScheduleActivitiesModal isOpen onClose={closeActivitiesModal} scheduleId={activitiesScheduleId} />
      )}
    </>
  );
}
